import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Chart extends Component {

  constructor(props) {
    super(props);
  }

  static propTypes = {
    chartSourceUrl: PropTypes.string.isRequired,
    chartStyle: PropTypes.object
  }

  render() {
    return (
      <iframe
        src={this.props.chartSourceUrl}
        style={this.props.chartStyle}
      />
    )
  }

}